import { render, staticRenderFns } from "./for-me-tool.vue?vue&type=template&id=0b3b4738&scoped=true"
import script from "./for-me-tool.vue?vue&type=script&lang=js"
export * from "./for-me-tool.vue?vue&type=script&lang=js"
import style0 from "./for-me-tool.vue?vue&type=style&index=0&id=0b3b4738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b4738",
  null
  
)

export default component.exports